import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'

import UsersContent from 'components/organisms/Users/UsersContent'
import PageTitle from 'components/atoms/PageTitle'
import {
  USERS_LIST_TYPE_SIXT_USERS,
  USERS_LIST_TYPE_PARTNERS,
} from 'components/organisms/Users/usersLib'

import {
  ROLE_SUPER_ADMIN,
  ROLE_ADMIN,
  ROLE_READ_ONLY,
  ROLES_SIXT,
  ROLE_B2C,
  useAuth,
} from '../../auth'

export default function Users() {
  const { t } = useTranslation()
  const { hasOneOfRoles } = useAuth()
  const canAccess = useMemo(() => hasOneOfRoles(ROLES_SIXT), [hasOneOfRoles])
  const userRoleHasReadOnly = useMemo(
    () => hasOneOfRoles([ROLE_READ_ONLY, ROLE_B2C]),
    [hasOneOfRoles]
  )

  if (!canAccess) {
    return <Navigate to="/agenda" />
  }

  return (
    <div className="content-container">
      <PageTitle label={t('users.title')} />

      {hasOneOfRoles([ROLE_SUPER_ADMIN]) && (
        <UsersContent
          enabledListTypes={[
            USERS_LIST_TYPE_SIXT_USERS,
            USERS_LIST_TYPE_PARTNERS,
          ]}
          defaultType={USERS_LIST_TYPE_SIXT_USERS}
          date-testid="users-air-view"
          contentIsReadOnly={userRoleHasReadOnly}
        />
      )}
      {hasOneOfRoles([ROLE_ADMIN, ROLE_READ_ONLY, ROLE_B2C]) && (
        <UsersContent
          enabledListTypes={[USERS_LIST_TYPE_PARTNERS]}
          defaultType={USERS_LIST_TYPE_PARTNERS}
          date-testid="users-sixt-view"
          contentIsReadOnly={userRoleHasReadOnly}
        />
      )}
    </div>
  )
}
